import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

const Menuicons = props => {
  const query = useStaticQuery(graphql`
    query Menuicons {
      allStrapiAccesosDirectos {
        edges {
          node {
            Titulo_uno
            Titulo_dos
            Site
            Enlace
            Icono {
              url
            }
          }
        }
      }
    }
  `)

  const projects = query.allStrapiAccesosDirectos.edges
  let url_global = process.env.GATSBY_API_URL
  return (
    <>
      <nav
        id="store"
        className="ubicar_nav_menuicon w-screen mx-auto container z-30 top-0"
        style={{
          marginTop: "2rem",
          position: "relative",
        }}
      >
        <div
          className="relative w-full gap-y-3 ubicar_container container mx-auto mt-0 py-3 px-14 flex flex-wrap gap-8 xl:grid grid-cols-4"
          style={{ marginTop: "-3rem" }}
        >
          {projects.map(({ node: project }, index) => {
            if (project.Site === props.site) {
              return (
                <div
                  key={index + project}
                  className="w-full sombra_sm menu_icon_oportunidad_citas p-2"
                  tabIndex="1"
                >
                  <div className="rounded p-2">
                    <a href={project.Enlace} target="_blank" tabIndex="1">
                      <div className="flex flex-row ubicar_dos_columnas_oportunidad_citas items-center transform hover:-translate-y-1 hover:scale-110 transition duration-500">
                        <div className="flex-shrink pr-4 alineacion_total_iconos_textos">
                          <img
                            src={url_global + project.Icono[0].url}
                            alt={`${project.Titulo_uno} ${project.Titulo_dos}`}
                            title={`${project.Titulo_uno} ${project.Titulo_dos}`}
                            className="tamano_menuicon_oportunidad_citas"
                            style={{ width: "4rem" }}
                          />
                        </div>
                        <div className="flex-1 alineacion_total_iconos_textos">
                          <div
                            className="whitespace-nowrap text-poppins-regular text-gray-500 ancho_menuicon_oportunidad_citas"
                            style={{ width: "51%" }}
                          >
                            <p className="mitexto mitexto_color text-green-default text-poppins-bold primer_titulo_menuicon_oportunidad">
                              {project.Titulo_uno}
                            </p>
                            <p className="mitexto mitexto_color text-poppins-regular segundo_titulo_menuicon_oportunidad">
                              {project.Titulo_dos}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              )
            }
          })}
        </div>
      </nav>
    </>
  )
}

Menuicons.propTypes = {
  siteTitle: PropTypes.string,
}

Menuicons.defaultProps = {
  siteTitle: ``,
}

export default Menuicons
